import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { GetAllLanguagesRes } from "types/content"
import languagesService from "api/contentService"

const useGetAllLanguages = (enabled = true) => {
  return useQuery("languages", async () => {
    try {
      const res: AxiosResponse<GetAllLanguagesRes> = await languagesService.getAllLanguages()

      return res.data
    } catch (err: any) {
      return err.response
    }
  }, { enabled, refetchOnMount: false, refetchOnWindowFocus: false })
}

export default useGetAllLanguages